import { render } from "./customerReviewsPage.vue?vue&type=template&id=c5794f04&ts=true"
import script from "./customerReviewsPage.vue?vue&type=script&lang=ts"
export * from "./customerReviewsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__